import TrainersComponent from "../../components/Trainers/Trainers.component";

const TrainersPage: React.FC = () => {
    return <TrainersComponent />;
};

export default TrainersPage;
